import { BookOpenCheck, LockKeyhole, SlidersHorizontal } from "lucide-react";

export function TrustSection() {
  return (
    <section className="trust-section" aria-labelledby="trust-title">
      <div>
        <span className="section-kicker">06 · Premissas à vista</span>
        <h2 id="trust-title">Simulação séria começa dizendo o que ela não é.</h2>
      </div>
      <div className="trust-list">
        <article>
          <BookOpenCheck aria-hidden="true" />
          <h3>Metodologia aberta</h3>
          <p>
            Amortização, juros, seguros e tarifas aparecem separados. O CET exibido é uma
            estimativa matemática, não o CET oficial de uma proposta.
          </p>
          <a href="/metodologia">Ler metodologia</a>
        </article>
        <article>
          <SlidersHorizontal aria-hidden="true" />
          <h3>Condições configuráveis</h3>
          <p>
            Taxas, quotas, idade final, prazo e custos são mantidos por instituição no painel
            protegido ou no arquivo de configuração.
          </p>
          <a href="/admin">Abrir configuração</a>
        </article>
        <article>
          <LockKeyhole aria-hidden="true" />
          <h3>Lead com consentimento</h3>
          <p>
            A simulação roda sem cadastro. Dados pessoais só são enviados quando a pessoa pede
            contato e confirma o consentimento.
          </p>
          <a href="/privacidade">Ver privacidade</a>
        </article>
      </div>
    </section>
  );
}

